// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appContainer_gNEcF {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
  background-color: #F6F6F6;
  position: relative;
  overflow-x: hidden;
}

.actions_UwU5l {
  display: flex;
  gap: 10px;
  align-items: center;
}

.mainContent_mswOo {
  height: 100px;
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  overflow-x: hidden;
  box-sizing: border-box;
}

.contentArea_tdwkq {
  display: flex;
  flex-direction: row;
  padding: 0px;
  background-color: #F6F6F6;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0px;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  overflow: visible;
  position: relative;
  box-sizing: border-box;
}
  


.activeSection_AIolX {
  font-weight: 500;
  position: relative;
  color: var(--00a3a3-color);
  background-color: var(--ececf1-background);
  border-radius: 15px;
  padding-left: 12px;
  border-left: 4px solid var(--00a3a3-color);
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.previewColumn_LlxqB {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  height: fit-content;
  max-height: 100%;
  overflow-y: scroll;
  flex-shrink: 0;
  padding: 0px;
  width: 250px;
  min-width: 250px;
  box-sizing: border-box;
  margin: 0;

  &::-webkit-scrollbar {
    display: none;
  }
}

@media (max-width: 1200px) {
  .mainContent_mswOo {
    max-width: 100%;
    /* padding: 0 20px; */
  }

  .contentArea_tdwkq {
    padding: 14px 6px;
    gap: 10px;
  }

  .previewColumn_LlxqB {
    width: 320px;
    min-width: 320px;
  }
}

@media (max-width: 1024px) {
  .mainContent_mswOo {
    padding: 0 16px;
  }

  .contentArea_tdwkq {
    padding: 16px 12px;
    gap: 16px;
  }

  .previewColumn_LlxqB {
    width: 300px;
    min-width: 300px;
  }
}

@media (max-width: 768px) {
  .mainContent_mswOo {
    flex-direction: column;
    overflow-y: auto;
    height: auto;
    width: 100%;
    padding: 0 16px;
    overflow-x: visible;
  }

  .contentArea_tdwkq {
    flex-direction: column;
    padding: 16px 0;
    align-items: stretch;
    height: auto;
    overflow: visible;
    width: 100%;
    margin: 0;
    gap: 20px;
    min-width: 0;
  }


  .previewColumn_LlxqB {
    position: relative;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: auto;
    max-height: none;
    align-self: stretch;
    margin: 0;
    overflow: visible;
    order: 1;
    display: flex;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .mainContent_mswOo {
    padding: 0 12px;
    overflow-x: visible;
  }

  .contentArea_tdwkq {
    padding: 12px 0;
    gap: 16px;
    overflow: visible;
    min-width: 0;
  }

  .previewColumn_LlxqB {
    width: 100%;
    margin: 0;
  }
}

@media (max-width: 375px) {
  .mainContent_mswOo {
    padding: 0 8px;
    overflow-x: visible;
  }

  .contentArea_tdwkq {
    padding: 8px 0;
    gap: 12px;
    overflow: visible;
  }



  .previewColumn_LlxqB {
    width: 100%;
    margin: 0;
  }
}

@media (max-width: 320px) {
  .mainContent_mswOo {
    padding: 0 6px;
    overflow-x: visible;
  }

  .contentArea_tdwkq {
    padding: 6px 0;
    gap: 10px;
    overflow: visible;
  }



  .previewColumn_LlxqB {
    width: 100%;
    margin: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/factura-customizer/FacturaCustomizer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;;;AAIA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;;EAET;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,SAAS;IACT,SAAS;IACT,YAAY;EACd;;;EAGA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,QAAQ;IACR,aAAa;IACb,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,SAAS;IACT,iBAAiB;EACnB;;;;EAIA;IACE,WAAW;IACX,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,SAAS;IACT,iBAAiB;EACnB;;;;EAIA;IACE,WAAW;IACX,SAAS;EACX;AACF","sourcesContent":[".appContainer {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  width: 100%;\n  background-color: #F6F6F6;\n  position: relative;\n  overflow-x: hidden;\n}\n\n.actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.mainContent {\n  height: 100px;\n  display: flex;\n  flex-grow: 1;\n  overflow: hidden;\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n.contentArea {\n  display: flex;\n  flex-direction: row;\n  padding: 0px;\n  background-color: #F6F6F6;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 0px;\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  overflow: visible;\n  position: relative;\n  box-sizing: border-box;\n}\n  \n\n\n.activeSection {\n  font-weight: 500;\n  position: relative;\n  color: var(--00a3a3-color);\n  background-color: var(--ececf1-background);\n  border-radius: 15px;\n  padding-left: 12px;\n  border-left: 4px solid var(--00a3a3-color);\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.previewColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative;\n  height: fit-content;\n  max-height: 100%;\n  overflow-y: scroll;\n  flex-shrink: 0;\n  padding: 0px;\n  width: 250px;\n  min-width: 250px;\n  box-sizing: border-box;\n  margin: 0;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n@media (max-width: 1200px) {\n  .mainContent {\n    max-width: 100%;\n    /* padding: 0 20px; */\n  }\n\n  .contentArea {\n    padding: 14px 6px;\n    gap: 10px;\n  }\n\n  .previewColumn {\n    width: 320px;\n    min-width: 320px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .mainContent {\n    padding: 0 16px;\n  }\n\n  .contentArea {\n    padding: 16px 12px;\n    gap: 16px;\n  }\n\n  .previewColumn {\n    width: 300px;\n    min-width: 300px;\n  }\n}\n\n@media (max-width: 768px) {\n  .mainContent {\n    flex-direction: column;\n    overflow-y: auto;\n    height: auto;\n    width: 100%;\n    padding: 0 16px;\n    overflow-x: visible;\n  }\n\n  .contentArea {\n    flex-direction: column;\n    padding: 16px 0;\n    align-items: stretch;\n    height: auto;\n    overflow: visible;\n    width: 100%;\n    margin: 0;\n    gap: 20px;\n    min-width: 0;\n  }\n\n\n  .previewColumn {\n    position: relative;\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    height: auto;\n    max-height: none;\n    align-self: stretch;\n    margin: 0;\n    overflow: visible;\n    order: 1;\n    display: flex;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .mainContent {\n    padding: 0 12px;\n    overflow-x: visible;\n  }\n\n  .contentArea {\n    padding: 12px 0;\n    gap: 16px;\n    overflow: visible;\n    min-width: 0;\n  }\n\n  .previewColumn {\n    width: 100%;\n    margin: 0;\n  }\n}\n\n@media (max-width: 375px) {\n  .mainContent {\n    padding: 0 8px;\n    overflow-x: visible;\n  }\n\n  .contentArea {\n    padding: 8px 0;\n    gap: 12px;\n    overflow: visible;\n  }\n\n\n\n  .previewColumn {\n    width: 100%;\n    margin: 0;\n  }\n}\n\n@media (max-width: 320px) {\n  .mainContent {\n    padding: 0 6px;\n    overflow-x: visible;\n  }\n\n  .contentArea {\n    padding: 6px 0;\n    gap: 10px;\n    overflow: visible;\n  }\n\n\n\n  .previewColumn {\n    width: 100%;\n    margin: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appContainer": `appContainer_gNEcF`,
	"actions": `actions_UwU5l`,
	"mainContent": `mainContent_mswOo`,
	"contentArea": `contentArea_tdwkq`,
	"activeSection": `activeSection_AIolX`,
	"previewColumn": `previewColumn_LlxqB`
};
export default ___CSS_LOADER_EXPORT___;
